import styled from 'styled-components';

import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';

const ModalTitle = styled.h6`
  margin: 0;
  padding: 24px 20px 8px;

  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1b1c1e;
`;

const ModalSubtitle = styled.p`
  padding: 0px 20px 16px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: #70737c;
`;

const ModalButtonBox = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 20px;

  button[data-type='text'] {
    font-weight: 500;
    font-size: 16px;
    line-height: 48px;

    background-color: transparent;

    color: #70737c;
  }

  button[data-type='cancel'] {
    height: 48px;
    padding: 0 24px;
    border-radius: 12px;

    background-color: #ffe6e6;

    font-weight: 600;
    font-size: 16px;
    line-height: 48px;

    color: #ff4242;
  }
`;

interface Props {
  handleModal: () => void;
  handleCancelBookingConfirm: () => void;
}

function CancelBookingConfirmModal({
  handleModal,
  handleCancelBookingConfirm,
}: Props) {
  return (
    <ModalContainer
      isMobile={false}
      isAbled={true}
      onClick={() => {}}
      onClose={() => {}}
      isBottomSheet
      style={{ gap: 0, maxWidth: '351px' }}
    >
      <ModalTitle>예약 확정을 취소할까요?</ModalTitle>

      <ModalSubtitle>
        취소된 예약건은 <strong>[일정조율형 예약확정하기]</strong> 리스트에서
        확인할 수 있어요.
      </ModalSubtitle>

      <ModalButtonBox>
        <button data-type="text" onClick={handleModal}>
          아니요
        </button>
        <button data-type="cancel" onClick={handleCancelBookingConfirm}>
          네, 취소할게요
        </button>
      </ModalButtonBox>
    </ModalContainer>
  );
}

export default CancelBookingConfirmModal;
